import React from 'react';
import { connect } from 'react-redux';
import properties from '../../../modules/ajio-util/properties';
import { createCookie } from '../../common/Cookie';
import { storageAvailable } from '../../common/storageAvailable';
import {generateEvent} from "../../../utils/dataGrinch";
import {gtmEventPush, gtmEventPushPLP, getStoreName } from "../../../modules/ga/GTMdatalayer";
import { getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import {
  getSearchFlags,
  getReleaseGA4Flag,
  getMasterGA4Flag,
  getMasterGA3Flag
} from '../../../refresh/selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


class CategoryButton extends React.Component {
  TypeClassification(type, pageId) {
    // const type = event.target.value;
    const path = pageId;
    var date;
    if (storageAvailable('localStorage')) {
      localStorage.setItem('categoryClicked', pageId);
      createCookie('categoryClicked', pageId, 730);
      if (type == 'core') {
        localStorage.setItem('categoryType', 'core');
        localStorage.setItem('categoryPath', path);
        date = new Date();
        localStorage.setItem('coreSelectedOn', date);
        createCookie('categoryType', 'core', 730);
        createCookie('categoryPath', path, 730);
        createCookie('coreSelectedOn', date, 730);
      } else {
        localStorage.setItem('categoryType', 'noncore');
      }
    }
    // ga('send', {
    //   hitType: 'event',
    //   eventCategory: 'buttonTap',
    //   eventAction: 'firstCategorySelection',
    //   eventLabel: catName
    // });
  }

  render() {
    const { buttonsCatNav = {} } = this.props;
    const buttonCategories =
      buttonsCatNav.filter(data => {
        if (data.nativeCategoryNavigationListDetails) {
          return true;
        }
        return false;
      })[0] || {};

    const { nativeCategoryNavigationListDetails = [] } = buttonCategories;
    const buttonCatNavDetails = nativeCategoryNavigationListDetails
      ? nativeCategoryNavigationListDetails.map((categories, n_key) => {
          let categoryNameImg = categories.imageDetails || [];
          let imgNameCategory = '';
          categoryNameImg.forEach(item => {
            if (item.imagePosition == 'NativeCategoryNameImage') {
              imgNameCategory = item.imageUrl;
            }
          });

          const masterGA3 = getMasterGA3Flag() === 'ON';
          const masterGA4 = getMasterGA4Flag() === 'ON';
          const releaseGA4 = getReleaseGA4Flag() === 'ON';
          const isGA4Feature = getFeatureVariant('isGA4Feature');
          let is_GA4 = true;

      const storeName = getStoreName();
      if (isGA4Feature === '1' && releaseGA4 && masterGA4 && !masterGA3 && storeName === 'ajio') {
        is_GA4 = true;
      };
      return(
          <a href={categories.nativeCategoryPageId} className="no-outline zoom-hover"
              data-ga-event-category="firstCategorySelection"
              data-ga-event-action="buttonTap"
              data-ga-event-label={categories.nativeCategoryName}
              key={`cat-nav-${n_key}`}
              onClick={event => {
                event.stopPropagation();

                if (is_GA4) {
                  generateEvent({
                    Event: 'TopLevelCategorySelection',
                    value: {
                      LinkUrl: categories.nativeCategoryPageId,
                      LinkName: categories.nativeCategoryName,
                      Type: categories.nativeCategoryType
                    }
                  });
                  gtmEventPushPLP({
                    event: 'hamburger_menu_interaction',
                    event_action: 'hamburger_menu_select',
                    menu_type: 'home page category',
                    menu_item_name: categories.nativeCategoryName || '',
                    page_type: window.pageType || '',
                    is_GA4
                  });
                } else {
                  generateEvent({
                    Event: 'TopLevelCategorySelection',
                    value: {
                      LinkUrl: categories.nativeCategoryPageId,
                      LinkName: categories.nativeCategoryName,
                      Type: categories.nativeCategoryType
                    }
                  });
                  gtmEventPush({
                    event: 'menu_navigation',
                    menu_type: 'home page category',
                    menu_item_name: categories.nativeCategoryName || '',
                    page_type: window.pageType || ''
                  });
                }

                window.location = categories.nativeCategoryPageId;
              }}
            >
              <img
                src={`${replaceWithJioCDN(imgNameCategory)}`}
                className="btn-cat-nav img-animate"
                onClick={() => {
                  this.TypeClassification(
                    categories.nativeCategoryType,
                    categories.nativeCategoryPageId
                  );
                }}
              />
            </a>
          );
        })
      : null;
    return (
      <div className="row-btn-cat-nav">
        <div>{buttonCatNavDetails}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { HomeReducer = {} } = state;
  const { pageDetails = [] } = HomeReducer;
  return {
    buttonsCatNav: pageDetails
  };
}
export default CategoryButton = connect(mapStateToProps)(CategoryButton);
